import React, { useEffect } from "react";
import CourseDetailHero from "../components/CoursesDetailePage/CourseDetailHero";
 
import Navbar from "../components/homepage/Navbar";
import TrainingGallery from "../components/CoursesDetailePage/TrainingGallery";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleCourses } from "../redux/slice/courseSlice";
import { Header, Footer } from "../shared";

const CoursesDetailPage = () => {
  const { courseDetails } = useSelector((state) => state.course);
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (id) {
      dispatch(getSingleCourses(id));
    }
  }, [id]);

  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <CourseDetailHero courseDetails={courseDetails} />
      <TrainingGallery courseDetails={courseDetails} />
      <Footer />
    </div>
  );
};

export default CoursesDetailPage;
